import type { ReactElement } from 'react'
import { StyleSheet } from 'react-native'
import { CheckboxGroup, CheckboxGroupProps } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

export type ProgramType = string

export interface ScheduleLegendItem {
  value: ProgramType
  title?: string | ReactElement
}

interface Props extends Omit<CheckboxGroupProps<ProgramType>, 'items'> {
  items?: ScheduleLegendItem[]
}

const ScheduleLegend = (props: Props) => {
  const { value, items, style, ...otherProps } = props
  const selectedItems = items || []
  return (
    <CheckboxGroup
      items={selectedItems}
      value={value || selectedItems.map((item) => item.value)}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

export default ScheduleLegend
